import {Component} from '@angular/core';
import {BaseError} from "./base-error";

@Component({
  templateUrl: './not-found-page.component.html',
  styleUrls: ['./base-error.scss']
})
export class NotFoundPageComponent extends BaseError {
}
